/* Drako collection auto-load — products load as you approach the bottom,
   like bushido.ca, instead of numbered pagination (Ian, Aug 14).
   Works with Dawn's #ProductGridContainer / #product-grid / pagination snippet
   and survives the facets AJAX re-render, which swaps the container's HTML. */
(function () {
  'use strict';

  function nextUrlFrom(root) {
    // the theme's pagination snippet swaps the --prev/--next classes between
    // the arrows, so the aria-label is the only trustworthy signal here
    var a = root.querySelector('.pagination a[aria-label="Next page"]');
    return a ? a.getAttribute('href') : null;
  }

  function setup(container) {
    var grid = container.querySelector('#product-grid');
    var pagination = container.querySelector('.pagination-wrapper');
    if (!grid || !pagination) return;
    // our own appends keep this pagination node; only a facets re-render swaps
    // it for a fresh one — never re-arm on a node we already consumed, or the
    // stale page-1 next-link would duplicate products
    if (pagination.hasAttribute('data-autoload')) return;
    pagination.setAttribute('data-autoload', '');

    var nextUrl = nextUrlFrom(pagination);
    pagination.style.display = 'none';
    if (!nextUrl) return;

    var sentinel = document.createElement('div');
    sentinel.className = 'drako-autoload-sentinel';
    sentinel.innerHTML =
      '<div class="drako-autoload-spinner" hidden aria-label="Loading more products">' +
      '<span></span><span></span><span></span></div>';
    pagination.parentNode.insertBefore(sentinel, pagination);
    var spinner = sentinel.firstChild;
    var busy = false;

    function loadNext() {
      if (busy || !nextUrl) return;
      busy = true;
      spinner.hidden = false;
      fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('#product-grid');
          if (newGrid) {
            while (newGrid.children.length) grid.appendChild(newGrid.children[0]);
          }
          var newPagination = doc.querySelector('.pagination-wrapper');
          nextUrl = newPagination ? nextUrlFrom(newPagination) : null;
          if (!nextUrl) {
            observer.disconnect();
            sentinel.remove();
          }
        })
        .catch(function (err) {
          console.error('[drako-autoload]', err);
          // keep the sentinel so the next intersection retries
        })
        .finally(function () {
          busy = false;
          spinner.hidden = true;
        });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) loadNext();
        });
      },
      { rootMargin: '900px 0px' }
    );
    observer.observe(sentinel);
  }

  function init() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    setup(container);

    // Dawn's facets.js replaces the container's innerHTML on every filter/sort
    // change, which wipes the sentinel — rebuild after each swap.
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          if (!container.querySelector('.drako-autoload-sentinel')) setup(container);
          return;
        }
      }
    });
    mo.observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
